export const trips = {
  appBarTitle: "Trips",
  totalTrips: "Total Trips",
  totalOngoingTrips: "Total Ongoing Trips",
  totalEndedTrips: "Total Ended Trips",
  totalCoveredKms: "Total Covered KMs",
  table: {
    tripId: "Trip ID",
    driverName: "Driver Name",
    ownerName: "Owner Name",
    teamName: "Team Name",
    startLocation: "Start Location",
    endLocation: "End Location",
    status: "Status",
    totalKms: "Total KMs Covered",
    dateStart: "Start Date",
    level: "Level",
    role: "Role",
    rolesOptions: {
      fleetOwner: "Fleet Owner",
      singleOwner: "Single Owner",
      driver: "Driver",
    },
    roleStatus: "Role Status",
    switchedFrom: "Switched from",
    roleStatusOptions: {
      primary: "Primary",
      switched: "Switched",
    },
  },
  filters: {
    status: "Status",
    totalKmsCovered: "Total KMs Covered",
    date: "Date",
    teamName: "Team Name",
    ownerName: "Owner Name",
    driverName: "Driver Name",
    level: "Level",
    role: "Role",
    roleStatus: "Role Status",
    options: {
      coveredKms: {
        lessThan1: "Less than 1 km",
        moreThanOrEqual1: "More than or equal 1 km",
        moreThanOrEqual5: "More than or equal 5 km",
        moreThanOrEqual50: "More than or equal 50 km",
        moreThanOrEqual100: "More than or equal 100 km",
      },
      role: {
        singleOwner: "Single Owner",
        fleetOwner: "Fleet Owner",
      },
      roleStatus: {
        primary: "Primary",
        switchedFromSingleOwner: "Switched from Single Owner",
        switchedFromFleetOwner: "Switched from Fleet Owner",
        switchedFromDriver: "Switched from Driver",
      }
    },
  },
  ongoing: "Ongoing",
  ended: "Ended",
  tripDetails: {
    title: "Trip Details",
    forceEndTrip: "Force End Trip",
    forceEndTripConfirm:
      "Are you sure you want to end this trip? This action cannot be undone.",
    plateNumber: "Plate Number",
    tripId: "Trip ID",
    teamName: "Team Name",
    driverName: "Driver Name",
    ownerName: "Owner Name",
    tripStartTime: "Trip Start Time",
    tripStartDate: "Trip Start Date",
    duration: "Trip Duration",
    totalKmsCovered: "Total KMs covered",
    startLocation: "Start Location",
    endLocation: "End Location",
    liveTrip: "Live Trip",
    tripEnded: "Trip Ended",
    noMapTitle: "Map is not ready yet",
    noMapNote: "Once trip ends, map will be available",
    km: "Km",
    min: "Min",
    level: "Level",
    role: "Role",
    rolesOptions: {
      fleetOwner: "Fleet Owner",
      singleOwner: "Single Owner",
      driver: "Driver",
    },
    roleStatus: "Role Status",
    switchedFrom: "Switched from",
    roleStatusOptions: {
      primary: "Primary",
      switched: "Switched",
    },
  },
};
